// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.1.10_@module-federation+runtime-tools@2.9.1__webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.1.10_@module-federation+runtime-tools@2.9.1__webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  display: flex;
  min-height: 48px;
  align-items: center;
}
.app-header-content-container {
  display: inherit;
  padding: 0 50px;
  flex-grow: 1;
}
.app-header-content-container div {
  display: inline-block;
}
.app-header-right-content {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/app-header/header.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEA;EACI,gBAAA;EACA,eAAA;EACA,YAAA;AAAJ;AAHA;EAMQ,qBAAA;AAAR;AAIA;EACI,iBAAA;AAFJ","sourcesContent":[".app-header {\n    display: flex;\n    min-height: 48px;\n    align-items: center;\n}\n\n.app-header-content-container {\n    display: inherit;\n    padding: 0 50px;\n    flex-grow: 1;\n\n    div {\n        display: inline-block;\n    }\n}\n\n.app-header-right-content {\n    margin-left: auto;\n}\n\n@root-entry-name: default;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
